<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;"><em>I dedicate this book to my Mum,</em></p>
<p style="text-align: center;"><em>who sees the light in everyday circumstances</em></p>
<p style="text-align: center;"><em>and always follows the bright side of life.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?3102b3cc